module.exports = __webpack_public_path__ + "static/media/dks48.f41dde57.png";